import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { AssistantConfigNamespace, AssistantConfigReducer } from './assistant-config.state';
import { loadAssistantConfig } from './assistant-settings.effects';

const effects = { loadAssistantConfig };
export const provideHrAssistantConfigEffects = provideEffects(effects);
export const provideHrAssistantConfigState = provideState(
  AssistantConfigNamespace,
  AssistantConfigReducer,
);

@NgModule({
  imports: [
    StoreModule.forFeature(AssistantConfigNamespace, AssistantConfigReducer),
    EffectsModule.forFeature(effects),
  ],
})
export class HrAssistantConfigStoreModule {}

export const provideHrAssistantConfigNgrx = [
  provideHrAssistantConfigEffects,
  provideHrAssistantConfigState,
];
